import { render, staticRenderFns } from "./especifica.vue?vue&type=template&id=0065e1e4&scoped=true&"
import script from "./especifica.vue?vue&type=script&lang=js&"
export * from "./especifica.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0065e1e4",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/views/consulta-nfe/especifica.vue
// module id = 296
// module chunks = 1